'use client';
import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import localStorage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import authSaga from '../GlobalSagas/auth.Saga';
import rootReducer from './Features/rootReducer';
import { userDataSaga } from '~/GlobalSagas/fetchPlugins.Saga';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'root',
  storage: localStorage,
  whitelist: [
    'auth',
    'userData',
    'sideBar',
  ],
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  middleware: [sagaMiddleware],
  reducer: persistedReducer,
  devTools: true,
});

export const persistor = persistStore(store);

sagaMiddleware.run(authSaga);
sagaMiddleware.run(userDataSaga);

export type AppDispatch = typeof store.dispatch;
export const wrapper = createWrapper(() => store);
export type RootState = ReturnType<typeof store.getState>;
